// Prev/next project navigation at the bottom of the detail page. Follows the
// same ordering as the projects listing (featured first, then newest).
//
// The published-project list is cached at module level so browsing from
// project to project costs one Firestore collection read per session, not
// one per page view.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { projectService } from '../../../services/projectService';

let projectListPromise = null;

function getPublishedProjectsCached() {
  if (!projectListPromise) {
    projectListPromise = projectService.getPublishedProjects().catch((err) => {
      // Don't cache failures — allow a retry on the next page view.
      projectListPromise = null;
      throw err;
    });
  }
  return projectListPromise;
}

function PagerCard({ project, dir }) {
  return (
    <Link
      to={`/projects/${project.id}`}
      className={`pd-pager__card pd-pager__card--${dir}`}
    >
      <img
        src={project.thumbnailUrl || project.imageUrl}
        alt=""
        className="pd-pager__thumb"
        loading="lazy"
        decoding="async"
      />
      <span className="pd-pager__text">
        <span className="pd-pager__label">
          {dir === 'prev' ? '← Previous' : 'Next →'}
        </span>
        <span className="pd-pager__title">{project.title}</span>
      </span>
    </Link>
  );
}

export default function ProjectPager({ currentId }) {
  const [neighbors, setNeighbors] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getPublishedProjectsCached()
      .then((projects) => {
        if (cancelled) return;
        const index = projects.findIndex((p) => p.id === currentId);
        if (index === -1) {
          setNeighbors(null);
          return;
        }
        setNeighbors({
          prev: projects[index - 1] || null,
          next: projects[index + 1] || null,
        });
      })
      .catch(() => {
        if (!cancelled) setNeighbors(null);
      });
    return () => {
      cancelled = true;
    };
  }, [currentId]);

  if (!neighbors || (!neighbors.prev && !neighbors.next)) return null;

  return (
    <nav className="pd-pager" aria-label="More projects">
      {neighbors.prev ? (
        <PagerCard project={neighbors.prev} dir="prev" />
      ) : (
        <span className="pd-pager__spacer" aria-hidden="true" />
      )}
      {neighbors.next ? (
        <PagerCard project={neighbors.next} dir="next" />
      ) : (
        <span className="pd-pager__spacer" aria-hidden="true" />
      )}
    </nav>
  );
}
